import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FormattedNumber, useIntl } from 'react-intl';
import moment from 'moment';

//Components
import {
  MenuComponent,
  TableButtons,
  SearchInput,
  IconButton,
  TableView,
  Tooltip,
  Pill,
} from '@gpstrackit/gtc-react-controls';


import {
  Typography,
  Grid,
} from '@mui/material';
import { Popover, Button } from 'Components';
import PillDownload from "Components/Pill";

import { NotificationManager } from 'Components/Notifications';

//Utils
import { usePaggination } from '../../../../../../core/hooks';
import { GetFormatForMoment } from 'Core/data/Helpers';
import { useDetectOutsideClick } from 'Core/hooks';
import { convertToKPH } from "Core/data/Helpers";
import {
  getMaintenanceValue,
  getMaintenanceLabel,
  getMaintenanceBar,
} from '../../../../../../core/hooks/utils';

//Views
import ScheduleMaintenanceService from '../../../../modals/scheduleMaintenanceService';
import DeleteMaintenanceService from '../../../../modals/deleteMaintenanceServiceUnit';

//Styles

import styles from 'Assets/sass/core/vars.scss';

//Actions
import {
  maintenanceVVDSearchMaintenanceServiceUnitsLogs,
  reset,
} from './redux/slice';

import {
  maintenanceVVDExportMaintenanceServiceUnits
} from '../scheduledServices/redux/slice';

import {
  openModalScheduleMaintenanceServiceUnit,
  openModalDeleteMaintenanceServiceUnit,
  catalogLoad,
} from 'Redux/actions';

export const PerformedServices = (props) => {
  const { id, vehicle, showTable, view } = props; 

  const pagination = usePaggination(null, null, true);
  const { messages, locate } = useIntl();
  const wrapperRef = useRef(null);
  const dispatch = useDispatch();
  //Redux States
  const openDeleteMaintenanceServiceUnit = useSelector(state => state.maintenanceDeleteMaintenanceServiceUnitRedux.open);
  const { loadingPerformedServices, performedServices } = useSelector(state => state.maintenancePerformedServicesRedux);
  const openScheduleMaintenanceService = useSelector(state => state.maintenanceScheduleMaintenanceServiceRedux.open);
  const loadingUnits = useSelector(state => state.catalogsRedux.loadingUnits);
  const { user } = useSelector(state => state.securityRedux);
  const [openCollapsedRowsOnHover, setOpenCollapsedRowsOnHover] = useState(null);
  const [selectedItems, setSelectedItems] = useState([])
  const [idToDelete, setIdToDelete] = useState(null);

  const detectClick = useDetectOutsideClick(wrapperRef);

  const tableRef = useRef();

  useEffect(() => {
    if (!detectClick.clickInside && isNumber(openCollapsedRowsOnHover)) {
      setOpenCollapsedRowsOnHover(false);
    }
  }, [detectClick.clickInside]);

  useEffect(() => {
    dispatch(maintenanceVVDSearchMaintenanceServiceUnitsLogs({ unitId: id }))
  }, []);

  useEffect(() => {
    dispatch(catalogLoad(["contacts"]))
    return () => {
      dispatch(reset({ performedServices: [] }))
      pagination?.onChangeData([]);
    }
  }, []);

  useEffect(() => {
    pagination.setColumns([
      {
        key: 'service.title',
        title: messages['scheduleDriverTask_service'],
        show: true,
        width: 200,
        sort: true,
        export: true,
        sortValue: (row) => row?.serviceUnit?.service?.title,
        exportValue: (row) => row?.serviceUnit?.service?.title,
        render: (row) => {
          return (
            <Grid container alignItems="center">
              <Grid item xs={9}>
                <span className="txtTitleService">{row?.serviceUnit?.service?.title}</span>
              </Grid>
              <Grid item xs={3}>
                {row?.serviceUnit &&
                  <MenuComponent
                    options={[messages['edit'], messages['vehicleDetailView_exportTask'], messages['delete']]}
                    icon="more_vert"
                    className="showInHover"
                    onClick={(type) => handleClickMenu(type, row?.serviceUnit, row)}
                    value={row?.serviceUnit}
                  />
                }
              </Grid>
            </Grid>
          )
        }
      },
      {
        key: 'miles',
        title: user.isKph ? messages['kilometers'] : messages['vehicleDetailView_miles'],
        show: true,
        width: 150,
        sort: true,
        export: true,
        sortValue: (row) => {
          if (!row.odometer || !row.startOdometer || !row.dueOdometer || !row.serviceUnit || !row.serviceUnit.service || !row.serviceUnit.service.miles) {
            return ""
          }
          const percentage = getMaintenanceValue("odometer", row.startOdometer, row.dueOdometer, row.odometer || 0)
          return percentage;
        },
        exportValue: (row) => {
          if (!row.odometer || !row.startOdometer || !row.dueOdometer || !row.serviceUnit || !row.serviceUnit.service || !row.serviceUnit.service.miles) {
            return null
          }
          let odometer = getMaintenanceBar("odometer", "Done", row.startOdometer, row.dueOdometer, row.odometer || 0, messages, true)
          return odometer
        },
        render: (row) => {
          return (
            <>
              {
                getMaintenanceBar("odometer", "Done", 
                  user.isKph ? convertToKPH(row.startOdometer) : row.startOdometer, 
                  user.isKph ? convertToKPH(row.dueOdometer) : row.dueOdometer, 
                  user.isKph ? convertToKPH(row.odometer || 0) : row.odometer || 0, 
                  messages)
              }
            </>
          )
        }
      },
      {
        key: 'days',
        title: messages['vehicleDetailView_days'],
        show: true,
        width: 150,
        sort: true,
        export: true,
        sortValue: (row) => {
          if (!row.maintenanceDate || !row.startDate || !row.dueDate || !row.serviceUnit || !row.serviceUnit.service || !row.serviceUnit.service.days) {
            return ""
          }
          const percentage = getMaintenanceValue("time", row.startDate, row.dueDate, row.maintenanceDate)
          return percentage;
        },
        exportValue: (row) => {
          if (!row.maintenanceDate || !row.startDate || !row.dueDate || !row.serviceUnit || !row.serviceUnit.service || !row.serviceUnit.service.days) {
            return null
          }
          let days = getMaintenanceBar("time", "Done", row.startDate, row.dueDate, row.maintenanceDate, messages, true)
          return days
        },
        render: (row) => {
          if (!row.maintenanceDate || !row.startDate || !row.dueDate || !row.serviceUnit || !row.serviceUnit.service || !row.serviceUnit.service.days) {
            return <div className="small-column"></div>
          }
          return (
            <>
              {
                getMaintenanceBar("time", "Done", row.startDate, row.dueDate, row.maintenanceDate, messages)
              }
            </>
          );
        }
      },
      {
        key: 'hours',
        title: messages['vehicleDetailView_engineHours'],
        show: true,
        width: 150,
        sort: true,
        export: true,
        sortValue: (row) => {
          if (!row.engineHours || !row.startEngineHours || !row.dueEngineHours || !row.serviceUnit || !row.serviceUnit.service || !row.serviceUnit.service.engineHours) {
            return "";
          }
          const percentage = getMaintenanceValue("engineHours", row.startEngineHours, row.dueEngineHours, row.engineHours || 0)
          return percentage;
        },
        exportValue: (row) => {
          if (!row.engineHours || !row.startEngineHours || !row.dueEngineHours || !row.serviceUnit || !row.serviceUnit.service || !row.serviceUnit.service.engineHours) {
            return null
          }
          let hours = getMaintenanceBar("engineHours", "Done", row.startEngineHours, row.dueEngineHours, row.engineHours || 0, messages, true)
          return hours
        },
        render: (row) => {
          if (!row.engineHours || !row.startEngineHours || !row.dueEngineHours || !row.serviceUnit || !row.serviceUnit.service || !row.serviceUnit.service.engineHours) {
            return <div className="small-column"></div>;
          }
          return (
            <>
              {
                getMaintenanceBar("engineHours", "Done", row.startEngineHours, row.dueEngineHours, row.engineHours || 0, messages)
              }
            </>
          );
        }
      },
      {
        key: 'cost',
        title: messages['vehicleDetailView_cost'],
        show: true,
        width: 100,
        sort: true,
        export: true,
        sortValue: (row) => {
          const format = { style: 'currency', currency: 'USD' };
          const numberFormat = new Intl.NumberFormat('en-US', format);
          return numberFormat.format(Math.abs(row?.serviceUnit?.service?.estimatedCost));
        },
        exportValue: (row) => {
          const format = { style: 'currency', currency: 'USD' };
          const numberFormat = new Intl.NumberFormat('en-US', format);
          return numberFormat.format(Math.abs(row?.serviceUnit?.service?.estimatedCost));
        },
        render: (row) => {
          // let cost = row && row?.serviceUnit?.service?.estimatedCost ? row?.serviceUnit?.service?.estimatedCost : 0;
          let getCoast = 0
          row?.maintenanceItems?.map(item => getCoast += item?.partsCost + item?.laborCost)
          return (<div><FormattedNumber value={getCoast} style="currency" currency="USD" /></div>);
        }
      },
      {
        key: 'maintenanceDate',
        title: messages['vehicleDetailView_completedDate'],
        show: true,
        width: 200,
        sort: true,
        export: true,
        sortValue: (row) => {
          return `${moment(row.maintenanceDate).format("h:mm a")} ${moment(row.maintenanceDate).format(GetFormatForMoment(user?.dateformat))}, ${row.odometer} ${messages['vehicleDetailView_miles']}, ${row.engineHours} ${messages['vehicleDetailView_engHrs']}`;
        },
        exportValue: (row) => {
          return `${moment(row.maintenanceDate).format("h:mm a")} ${moment(row.maintenanceDate).format(GetFormatForMoment(user?.dateformat))}, ${row.odometer} ${messages['vehicleDetailView_miles']}, ${row.engineHours} ${messages['vehicleDetailView_engHrs']}`;
        },
        render: (row) => {
          if (!row.maintenanceDate) {
            return <div className="small-column"></div>
          }
          return (
            <div>
              <div style={{ fontSize: 16 }}>
                {moment(row.maintenanceDate).format("h:mm a")} {moment(row.maintenanceDate).format(GetFormatForMoment(user.dateformat))}
              </div>
              <div className="text-muted">
                {user.isKph ? convertToKPH(row.odometer) : row.odometer} 
                {user.isKph ? ` ${messages['vehicleDetailView_km']}, ` : ` ${messages['vehicleDetailView_miles']}, `} 
                {user.isKph ? convertToKPH(row.engineHours) : row.engineHours} {messages['vehicleDetailView_engHrs']}
              </div>
            </div>
          )
        }
      },
      {
        key: 'attachments',
        title: messages['vehicleDetailView_attachments'],
        show: true,
        width: 100,
        sort: true,
        export: true,
        sortValue: (row) => row && row.fileIds ? row.fileIds.length : 0,
        exportValue: (row) => row?.fileIds?.length,
        render: (row) => {
          return (
            <div className='text-center'>
              {row && row.files && row.files.length > 0 && (
                <Popover
                  component={
                    <IconButton
                      placement="bottom"
                      variant="secondary"
                      icon="attach_file"
                      size="small"
                      onClick={() => { }}
                    />
                  }
                >
                  <div style={{ padding: 10, marginTop: 5 }}>
                    {row.files.map((file, index) => {
                      const { id, originalName, repositoryCode, fileKey } = file
                      return (
                        <PillDownload
                          key={index}
                          item={{
                            id,
                            originalName,
                            repositoryCode,
                            fileKey
                          }}
                          textFieild="originalName"
                          colorField="color"
                          isDownload
                          noDelete={true}
                        />
                      )
                    })}
                  </div>
                </Popover>
              )}
            </div>
          )
        }
      },
      {
        key: 'notes',
        title: messages['vehicleDetailView_notes'],
        show: true,
        width: 150,
        sort: true,
        export: true,
        sortValue: (row) => row?.notes || "",
        render: (row) => {
          if (!row.notes) return <div />
          return (
            <div style={{ width: 150, cursor: 'pointer' }}>
              <Tooltip
                placement="bottom"
                title={row.notes}
              >
                <Grid container wrap="nowrap">
                  <Grid item xs zeroMinWidth>
                    <Typography noWrap>
                      {row.notes}
                    </Typography>
                  </Grid>
                </Grid>
              </Tooltip>
            </div>
          )
        }
      }
    ]);
  }, [locate, user])

  useEffect(() => {
    if (performedServices) {
      let data = performedServices ? performedServices.map(service => { return { ...service, children: service.maintenanceItems.length } }) : []
      pagination.onChangeData(data);
    }
  }, [performedServices])

  var isNumber = function isNumber(value) {
    return typeof value == 'number';
  }

  const onCollapse = (row) => {
    return (
      <div style={{ padding: '16px 82px', backgroundColor: "#f7f9fc" }}>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          style={{ paddingBottom: 10 }}
          wrap="nowrap"
          spacing={3}
        >
          <Grid item xs={3} zeroMinWidth className='MuiTableCell-head'>{messages['vehicleDetailView_serviceItems']}</Grid>
          <Grid item xs={3} className='MuiTableCell-head'>{messages['vehicleDetailView_laborCost']}</Grid>
          <Grid item xs={3} className='MuiTableCell-head'>{messages['vehicleDetailView_partsCost']}</Grid>
          <Grid item xs={3} className='MuiTableCell-head'>{messages['vehicleDetailView_totalCost']}</Grid>
        </Grid>

        {
          row?.maintenanceItems.map((item, index) => {
            return (
              <Grid
                key={index}
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                wrap="nowrap"
                spacing={3}
              >
                <Grid item xs={3} zeroMinWidth>
                  <Typography noWrap>{item?.serviceItemName}</Typography>
                </Grid>
                <Grid item xs={3}><FormattedNumber value={item.laborCost} style="currency" currency="USD" /></Grid>
                <Grid item xs={3}><FormattedNumber value={item.partsCost} style="currency" currency="USD" /></Grid>
                <Grid item xs={3}><FormattedNumber value={item.partsCost + item.laborCost} style="currency" currency="USD" /></Grid>
              </Grid>
            )
          })
        }
      </div>
    )
  }

  const handleClickMenu = (type, serviceUnit, row) => {
    if (type === messages['edit']) {
      dispatch(openModalScheduleMaintenanceServiceUnit({ open: true, id: serviceUnit.id }))
    } else if (type === messages['vehicleDetailView_exportTask']) {
      let services = JSON.stringify({ service: serviceUnit?.serviceId, serviceLogId: serviceUnit?.id })
      dispatch(maintenanceVVDExportMaintenanceServiceUnits({ services: [services], serviceType: 'COMPLETE', units: [{ "id": id, "type": "Unit" }] }))

      NotificationManager.success(
        messages['vehicleDetailView_exportGenerated'],
        messages['success'],
        3000,
        null,
        null,
        'Success',
      );
    } else if (type === messages['delete']) {
      setIdToDelete(row.id)
      const serviceRow = {
        id: row.serviceUnit.id,
        service: {
          ...row.serviceUnit.service,
          idToDelete: row.id
        }
      }
      dispatch(openModalDeleteMaintenanceServiceUnit({ open: true, service: serviceRow }))
    }
  };

  const refreshTable = () => {
    dispatch(maintenanceVVDSearchMaintenanceServiceUnitsLogs({ unitId: id }))
  }

  return (
    <Grid item container style={{ marginTop: 15 }}>
      <Grid container direction="row" justifyContent="space-between" alignItems="center">
        <Grid item xs={6} sm={4}>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
          >
            <Grid item style={{ display: 'flex' }}>
              <Button
                tooltip={messages["vehicleDetailView_exportTask"]}
                icon="get_app"
                type="icon"
                disabled={!selectedItems?.length}
                onClick={(type) => {
                  let services = selectedItems.map((su) => (JSON.stringify({
                    service: su.serviceUnit.serviceId,
                    serviceLogId: su.serviceUnit.id,
                  })));
                  dispatch(maintenanceVVDExportMaintenanceServiceUnits({ services, serviceType: 'COMPLETE', units: [{ "id": id, "type": "Unit" }] }))
                  NotificationManager.success(
                    messages['vehicleDetailView_exportGenerated'],
                    messages['success'],
                    3000,
                    null,
                    null,
                    'Success',
                  );
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={4} style={{ display: 'flex' }}>
          <Pill
            item={{ id: 1, label: messages['vehicleDetailView_scheduledList'], color: view === "scheduled" ? styles.blue_gtc : styles.lightGray }}
            onClick={() => showTable('scheduled')}
          />
          <Pill
            item={{ id: 1, label: messages['vehicleDetailView_performedList'], color: view === "performed" ? styles.blue_gtc : styles.lightGray }}
            onClick={() => showTable('performed')}
          />
        </Grid>
        <Grid item xs={12} sm={4} className="mb-10 text-right">
          <SearchInput
            placeholder={messages['search']}
            searchText={pagination.searchText}
            onSearchText={pagination.onSearchChange}
          />
        </Grid>
      </Grid>
      <TableView
        ref={tableRef}
        keyColumn="id"
        {...pagination}
        loading={loadingPerformedServices || loadingUnits}
        topheight={285}
        hideDragable
        onCollapse={onCollapse}
        hideAllInPagination
        onSelectedItems={(items) => setSelectedItems(items)}
      />
      {openDeleteMaintenanceServiceUnit && <DeleteMaintenanceService refresh={() => refreshTable()} isComplete={true}/>}
      {openScheduleMaintenanceService &&
        <ScheduleMaintenanceService
          vehicle={vehicle}
          refresh={() => dispatch(maintenanceVVDSearchMaintenanceServiceUnitsLogs({ unitId: id }))}
        />
      }
    </Grid>
  );
};



export default PerformedServices
